import { TecnologiaNode } from '@gql/graphql'
import { MenuItemType } from '@utils/types'
import { CardSwiper } from '@components/organisms'
import styles from './TecnologieSection.module.sass'

interface Props {
  tecnologie: TecnologiaNode[]
  item: MenuItemType
  theme?: 'white' | 'neutral10' | 'neutral20'
  className?: string
}

const TecnologieSection = (props: Props) => {
  const { tecnologie = [], item = undefined, theme = 'neutral20', className = '' } = props

  return tecnologie?.length > 0 ? (
    <CardSwiper
      id="tecnologie-swiper"
      item={{
        ...item,
        children: tecnologie.map((x) => ({
          pk: x.pk,
          name: x.title,
          description: x.description,
          url: x.url,
          image: x.listingImage,
          imageAlt: x.alt,
        })),
      }}
      theme={theme}
      size="md"
      className={`${styles.root} ${className}`}
    />
  ) : (
    <></>
  )
}

export default TecnologieSection
